import type { ReactNode } from 'react';

interface SettingsSectionHeaderProps {
  children: ReactNode;
}

export function SettingsSectionHeader({ children }: SettingsSectionHeaderProps) {
  return <h2 className="text-lg font-semibold text-foreground">{children}</h2>;
}
